import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { StatusPill } from 'components/Pills/StatusPills';

import styles from './ToggleSwitch.module.scss';

export const ToggleSwitch = ({
  label,
  name,
  className,
  tooltip,
  inputProps,
  disabled = false,
  register = () => {},
  status = null,
}) => {
  return (
    <div className={cn(styles.root, { [className]: className })}>
      <div className="d-flex align-items-center u-gap">
        {label && (
          <label>
            {label}
            {tooltip && (
              <OverlayTrigger placement="bottom" overlay={<Tooltip>{tooltip}</Tooltip>}>
                <div className={styles.tooltip}>
                  <FeatherIcon icon="help-circle" />
                </div>
              </OverlayTrigger>
            )}
          </label>
        )}
        {status && (
          <StatusPill text={status.text} status={status.status} className={styles.status} />
        )}
      </div>

      <div className={styles.slider}>
        <input disabled={disabled} type="checkbox" {...register(name)} {...inputProps} />
        <span></span>
      </div>
    </div>
  );
};

ToggleSwitch.propTypes = {
  label: PropTypes.string,
  register: PropTypes.func,
  name: PropTypes.string,
  className: PropTypes.string,
  inputProps: PropTypes.object,
};
